module.exports = __webpack_public_path__ + "img/search_no_results.137ab4cb.jpg";